// A breadcrumb link goes back to the last URL of a list, not to the bare
// path. The list pages keep sort, search and filters in the query string, so
// the link must bring that query string back.
//
// The map lives in memory. Nothing needs to survive a reload.

const MAX_ENTRIES = 200;

const lastSearch = new Map<string, string>();

/** Remember the query string of a location. An empty query string clears the entry. */
export function rememberLocation(pathname: string, search: string): void {
    const path = normalisePath(pathname);
    // Delete first, so that the newest entry moves to the end of the map.
    lastSearch.delete(path);
    if (!search || search === '?') return;
    lastSearch.set(path, search);
    if (lastSearch.size > MAX_ENTRIES) {
        const oldest = lastSearch.keys().next().value;
        if (oldest !== undefined) lastSearch.delete(oldest);
    }
}

/**
 * The link target for a crumb. If `to` has a query string, or no query string
 * is remembered for it, the result is `to` as it is.
 */
export function crumbHref(to: string): string {
    if (to.includes('?') || to.includes('#')) return to;
    const search = lastSearch.get(normalisePath(to));
    return search ? `${to}${search}` : to;
}

/** Forget all remembered locations. A test uses this. */
export function resetRememberedLocations(): void {
    lastSearch.clear();
}

function normalisePath(path: string): string {
    return path.length > 1 ? path.replace(/\/+$/, '') : path;
}
